import { DynamicPageProps } from 'types/DynamicPageProps';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { DataFormProps } from 'types/InputsRedirectableLinkProps';

export function returListOptionsDynamicPage(
	listPages: DynamicPageProps[]
): SelectInputItemProps[] {
	const listOptions: SelectInputItemProps[] = [];

	listPages.forEach((item) => {
		listOptions.push({ id: item.id, option: item.name });
	});

	return listOptions;
}

export function verifyIfFormCanSave(
	dataForm: DataFormProps,
	setCanSaveModuleOnBack: React.Dispatch<React.SetStateAction<boolean>>,
	setMessageErrorForm: React.Dispatch<React.SetStateAction<string>>
) {
	if (dataForm.type === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Tipo"');
		return;
	}

	if (dataForm.links.length === 0) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Cadastre pelo menos 1 link');
		return;
	}

	setCanSaveModuleOnBack(true);
}
